exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#formDiv[data-v-67498a3c] {\n  /* min-height: calc(100vh - 120px); */\n}\n.cardTitleClass[data-v-67498a3c] {\n  font-weight: 500 !important;\n  font-size: 20px !important;\n  padding-bottom: 5px !important;\n}\n.vDialogClass[data-v-67498a3c] {\n  background-color: #fff !important;\n}\n", ""]);

// exports
